module.exports = __webpack_public_path__ + "static/product.fb525a9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product.jpg
// module id = 361
// module chunks = 170844033123148